import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Paper, Stack, TextField, Typography, Alert } from "@mui/material";
import api from "../services/api";

export default function VerifyPage() {
  const [state, setState] = useState<'loading'|'ok'|'error'>("loading");
  const [message, setMessage] = useState<string>("Verifying your email…");

  useEffect(() => {
    const url = new URL(window.location.href);
    const qEmail = url.searchParams.get('email');
    if (qEmail) setEmail(qEmail);
    const token = url.searchParams.get('token');
    if (!token) {
      setState('error');
      setMessage('Missing verification token');
      return;
    }
    api.get(`/shops/verify`, { params: { token } })
      .then((res) => {
        setState('ok');
        setMessage(res.data?.message || 'Email verified. You can now login.');
      })
      .catch((err) => {
        setState('error');
        setMessage(err?.response?.data?.message || 'Verification failed');
      });
  }, []);

  const [email, setEmail] = useState("");
  const [resendMsg, setResendMsg] = useState<string>("");

  const resend = async () => {
    setResendMsg("");
    try {
      await api.post('/shops/resend-verification', { email });
      setResendMsg('Verification email sent. Please check your inbox.');
    } catch (e:any) {
      setResendMsg(e?.response?.data?.message || 'Could not resend verification email');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>
      <Paper sx={{ p: 4, maxWidth: 520, width: '100%' }}>
        <Stack spacing={2} alignItems="center">
          {state === 'loading' && <CircularProgress />}
          <Typography variant="h5" fontWeight={900} textAlign="center">
            {state === 'loading' ? 'Please wait' : state === 'ok' ? 'Email Verified' : 'Verification Error'}
          </Typography>
          <Typography color="text.secondary" textAlign="center">{message}</Typography>
          {/* Guidance */}
          <Alert severity="info" sx={{ width: '100%' }}>
            {email ? (
              <>We sent a verification email to <b>{email}</b>. Check your Inbox and Spam/Promotions. If found in Spam, please mark <b>Not spam</b> so future emails land in your inbox.</>
            ) : (
              <>Check your Inbox and Spam/Promotions. If found in Spam, please mark <b>Not spam</b>.</>
            )}
          </Alert>
          <Button variant="contained" href="/login">Go to Login</Button>
          {state !== 'ok' && (
            <>
              <Typography sx={{ mt: 2 }} fontWeight={700}>Didn’t get the email?</Typography>
              <TextField fullWidth placeholder="Enter signup email" value={email} onChange={(e)=>setEmail(e.target.value)} size="small" />
              <Button onClick={resend} variant="outlined">Resend Verification Email</Button>
              {!!resendMsg && <Typography color="text.secondary">{resendMsg}</Typography>}
            </>
          )}
        </Stack>
      </Paper>
    </Box>
  );
}
